import { render } from "./JobCategories.vue?vue&type=template&id=468f3aa6&scoped=true"
import script from "./JobCategories.vue?vue&type=script&lang=js"
export * from "./JobCategories.vue?vue&type=script&lang=js"

import "./JobCategories.vue?vue&type=style&index=0&id=468f3aa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468f3aa6"]])

export default __exports__